import { createWebHistory, createRouter } from "vue-router";
import Body from '../components/body';

/* Dashboards */
import Dashboard from '../pages/dashboard/dashboard';
import DeviceDetail from '../pages/dashboard/device_detail.vue';

import RawMaterials from '../pages/raw_materials/raw_materials.vue'
import AddMaterial from '../pages/raw_materials/add_material.vue'
import EditMaterial from '../pages/raw_materials/edit_material.vue'
import MaterialStockLogs from '../pages/raw_materials/stock_logs.vue'

import Staffs from '../pages/staffs/staffs.vue'
import AddStaff from '../pages/staffs/add.vue'
import EditStaff from '../pages/staffs/edit.vue'
import StaffDetails from '../pages/staffs/profile.vue'
import TechnicianJobs from '../pages/staffs/jobs.vue'
import TechnicianProducts from '../pages/staffs/products.vue'
import AddTechnicianProduct from '../pages/staffs/add_product.vue'
import TechnicianProductLogs from '../pages/staffs/stock_logs.vue'
import StaffLogs from '../pages/staffs/staff_logs.vue'

import Vendors from '../pages/vendors/vendors.vue'
import VendorDetails from '../pages/vendors/profile.vue'
import VendorMaterials from '../pages/vendors/raw_materials.vue'
import AddVendorMaterial from '../pages/vendors/add_material.vue'
import VendorMaterialLogs from '../pages/vendors/stock_logs.vue'
import Suppliers from '../pages/vendors/suppliers.vue'

import Sims from '../pages/sims/sims.vue'

import Boards from '../pages/boards/boards.vue'
import BoardDetail from '../pages/boards/board_detail.vue'
import BoardInfo from '../pages/boards/board_info.vue'
import FailedBoards from '../pages/boards/failed.vue'
import Enclosure from '../pages/boards/enclosure.vue'
import BoardBatches from '../pages/boards/board_batches.vue'
import BatchDetails from '../pages/boards/batch_details.vue'

import BuyBackDevices from '../pages/buy_back/buy_back_devices.vue'
import AddBuyBackDevice from '../pages/buy_back/add_buy_back_device.vue'
import ReplacementDevices from '../pages/buy_back/replacement_devices.vue'
import AddReplacementDevice from '../pages/buy_back/add_replacement_device.vue'

import FinalProduction from '../pages/final_production/final_production.vue'

//Devices
import ViewDevices from '../pages/devices/view-devices.vue'
import DeviceDetailsPage from '../pages/devices/device_details.vue'

//Vehicles
import ViewVehicles from '../pages/vehicles/view-vehicles.vue'
import EditVehicle from '../pages/vehicles/edit-vehicle.vue'

import Complaints from '../pages/complaint_management/complaint_list.vue'
import AddComplaint from '../pages/complaint_management/add_complaint.vue'
import UpdateComplaint from '../pages/complaint_management/edit_complaint.vue'
import ComplaintDetails from '../pages/complaint_management/complaint_details.vue'
import DeviceComplaintLog from '../pages/complaint_management/solved_complaints.vue'
import SolvedComplaintDetails from '../pages/complaint_management/solved_complaint_details.vue'
import PendingServicePayments from '../pages/complaint_management/pending_payments.vue'
import SupportServices from '../pages/complaint_management/support_service.vue'

import CourierAccount from '../pages/accounts/courier.vue'
import VerifyCourier from '../pages/accounts/verify_courier.vue'
import CourierRepayment from '../pages/accounts/courier_repayment.vue'
import CourierDetails from '../pages/accounts/courier_details.vue'
import BankAccounts from '../pages/accounts/bank_accounts.vue'
import BankAccountTransactions from '../pages/accounts/bank_transactions.vue'
import UserAccounts from '../pages/accounts/user_accounts.vue'
import UserPaymentLogs from '../pages/accounts/user_payment_logs.vue'
import UserCreditLogs from '../pages/accounts/user_credit_logs.vue'
import UserDues from '../pages/accounts/user_dues.vue'
import UserAccountPayment from '../pages/accounts/user_account_payment.vue'
import VendorCredits from '../pages/accounts/vendor_credits.vue'
import VendorInvoices from '../pages/accounts/vendor_invoices.vue'
import VendorPayment from '../pages/accounts/vendor_payment.vue'
import PaymentIn from '../pages/accounts/payment_in.vue'
import Expense from '../pages/accounts/expense.vue'
import Purchase from '../pages/accounts/purchase.vue'
import Sales from '../pages/accounts/sales.vue'
import EditSale from '../pages/accounts/edit_sale.vue'

import ExpiredDevices from '../pages/renewal/renewal.vue'
import RenewedDevices from '../pages/renewal/renewed.vue'
import UpdateVehicleData from '../pages/renewal/update_vehicle.vue'
import UpcomingExpiringDevices from '../pages/renewal/upcoming_expire.vue'
import RechargeDevice from '../pages/renewal/recharge.vue'
import PendingPayments from '../pages/renewal/pending_payment.vue'
import RequestedDevices from '../pages/renewal/requested.vue'
import RechargedDevices from '../pages/renewal/recharged.vue'
import EnquiryDevices from '../pages/renewal/enquiry.vue'
import AllDevices from '../pages/renewal/all_devices.vue'
import RenewalLogs from '../pages/renewal/renewal_log.vue'
import DeviceExtension from '../pages/renewal/extension.vue'
import DeviceTopup from '../pages/renewal/topup.vue'
import ExtendedDevices from '../pages/renewal/extended.vue'
import IccidDetails from '../pages/renewal/iccid_details.vue'

import SafeCustodyDevices from '../pages/safe_custody/safe_custody.vue'
import DeactivatedDevices from '../pages/safe_custody/deactivated.vue'

import RawMaterialStockReport from '../pages/reports/raw_material_stock.vue'
import WorkReport from '../pages/reports/work_report.vue'
import TagReport from '../pages/reports/tag_report.vue'
import CallLogReport from '../pages/reports/call_log_report.vue'

import Settings from '../pages/settings/settings.vue'
import Products from '../pages/products/products.vue'
import ProductStockLogs from '../pages/products/stock_logs.vue'
import Supports from '../pages/support_management/supports.vue'
import AddSupport from '../pages/support_management/add_support.vue'
import SupportDetails from '../pages/support_management/support_details.vue'
import CompletedSupports from '../pages/support_management/completed.vue'
import ApiRequesters from '../pages/support_management/api_requesters.vue'
import ApiRequesterLogs from '../pages/support_management/api_requester_logs.vue'

import Commands from '../pages/commands/commands.vue'


//Auth
import login from '../auth/login';
import Register from '../auth/register';


const routes = [
  {
    path: '/',
    component: Body,

    children: [
      {
        path: '',
        name: 'defaultRoot',
        component: Dashboard,
        meta: {
          title: ' Dashboard',
        }
      },
      {
        path: "device_detail",
        name: "device_detail",
        component: DeviceDetail,
        meta: {
          title: "Device Detail",
        },
      },
      {
        path: "raw_materials",
        name: "raw_materials",
        component: RawMaterials,
        meta: {
          title: "Raw Materials",
        },
      },
      {
        path: "add_material",
        name: "add_material",
        component: AddMaterial,
        meta: {
          title: "Add Raw Material",
        },
      },
      {
        path: "edit_material",
        name: "edit_material",
        component: EditMaterial,
        meta: {
          title: "Edit Raw Material",
        },
      },
      {
        path: "material_stock_logs/:id",
        name: "material_stock_logs",
        component: MaterialStockLogs,
        meta: {
          title: "Raw Material Stock Logs",
        },
      },

      {
        path: "staffs",
        name: "staffs",
        component: Staffs,
        meta: {
          title: "Staffs",
        },
      },
      {
        path: "add_staff",
        name: "add_staff",
        component: AddStaff,
        meta: {
          title: "Add Staff",
        },
      },
      {
        path: "edit_staff/:id",
        name: "edit_staff",
        component: EditStaff,
        meta: {
          title: "Edit Staff",
        },
      },
      {
        path: "staff_details/:id",
        name: "staff_details",
        component: StaffDetails,
        meta: {
          title: "Staff Details",
        },
      },
      {
        path: "technician_jobs",
        name: "technician_jobs",
        component: TechnicianJobs,
        meta: {
          title: "Technician Jobs",
        },
      },
      {
        path: "technician_products",
        name: "technician_products",
        component: TechnicianProducts,
        meta: {
          title: "Technician Products",
        },
      },
      {
        path: "add_technician_product",
        name: "add_technician_product",
        component: AddTechnicianProduct,
        meta: {
          title: "Add Technician Product",
        },
      },
      {
        path: "technician_product_logs",
        name: "technician_product_logs",
        component: TechnicianProductLogs,
        meta: {
          title: "Technician Product Logs",
        },
      },
      {
        path: "staff_logs/:id",
        name: "staff_logs",
        component: StaffLogs,
        meta: {
          title: "Staff Logs",
        },
      },

      {
        path: "vendors",
        name: "vendors",
        component: Vendors,
        meta: {
          title: "Vendors",
        },
      },
      {
        path: "vendor_details/:id",
        name: "vendor_details",
        component: VendorDetails,
        meta: {
          title: "Vendor Details",
        },
      },
      {
        path: "vendor_materials/:id",
        name: "vendor_materials",
        component: VendorMaterials,
        meta: {
          title: "Vendor Raw Materials",
        },
      },
      {
        path: "add_vendor_material/:id",
        name: "add_vendor_material",
        component: AddVendorMaterial,
        meta: {
          title: "Add Vendor Material",
        },
      },
      {
        path: "vendor_material_logs/:vendor_id/:raw_material_id",
        name: "vendor_material_logs",
        component: VendorMaterialLogs,
        props: true,
        meta: {
          title: "Vendor Material Logs",
        },
      },

      {
        path: "sims",
        name: "sims",
        component: Sims,
        meta: {
          title: "SIMs",
        },
      },

      {
        path: "boards",
        name: "boards",
        component: Boards,
        meta: {
          title: "Boards",
        },
      },
      {
        path: "board_detail/:id",
        name: "board_detail",
        component: BoardDetail,
        meta: {
          title: "Board Detail",
        },
      },
      {
        path: "board_info/:id",
        name: "board_info",
        component: BoardInfo,
        meta: {
          title: "Board Info",
        },
      },
      {
        path: "failed_boards",
        name: "failed_boards",
        component: FailedBoards,
        meta: {
          title: "Firmware Failed",
        },
      },
      {
        path: "enclosure",
        name: "enclosure",
        component: Enclosure,
        meta: {
          title: "Enclosure",
        },
      },
      {
        path: "board_batches",
        name: "board_batches",
        component: BoardBatches,
        meta: {
          title: "Board Batches",
        },
      },
      {
        path: "batch_details/:id",
        name: "batch_details",
        component: BatchDetails,
        meta: {
          title: "Batch Details",
        },
      },
      {
        path: "final_production",
        name: "final_production",
        component: FinalProduction,
        meta: {
          title: "Final Production",
        },
      },

      {
        path: "buy_back_devices",
        name: "buy_back_devices",
        component: BuyBackDevices,
        meta: {
          title: "Buy Back Devices",
        },
      },
      {
        path: "add_buy_back_device",
        name: "add_buy_back_device",
        component: AddBuyBackDevice,
        meta: {
          title: "Add Buy Back Device",
        },
      },
      {
        path: "replacement_devices",
        name: "replacement_devices",
        component: ReplacementDevices,
        meta: {
          title: "Replacement Devices",
        },
      },
      {
        path: "add_replacement_device",
        name: "add_replacement_device",
        component: AddReplacementDevice,
        meta: {
          title: "Add Replacement Device",
        },
      },
      {
        path: "edit_replacement_device/:id",
        name: "edit_replacement_device",
        component: AddReplacementDevice,
        meta: {
          title: "Edit Replacement Device",
        },
      },
      {
        path: "edit_buy_back_device/:id",
        name: "edit_buy_back_device",
        component: AddBuyBackDevice,
        meta: {
          title: "Edit Buy Back Device",
        },
      },

      {
        path: '/view_devices',
        name: 'view_devices',
        component: ViewDevices,
        meta: {
          title: 'View Devices',
        }
      },
      {
        path: '/device_details_page',
        name: 'device_details_page',
        component: DeviceDetailsPage,
        meta: {
          title: 'Device Details',
        }
      },

      {
        path: '/view_vehicles',
        name: 'view_vehicles',
        component: ViewVehicles,
        meta: {
          title: 'View Vehicles',
        }
      },
      {
        path: '/edit_vehicle/:id',
        name: 'edit_vehicle',
        component: EditVehicle,
        meta: {
          title: 'Edit Vehicle',
        }
      },

      {
        path: "complaint_management",
        name: "complaint_management",
        component: Complaints,
        meta: {
          title: "Complaint Management",
        },
      },
      {
        path: "add_complaint",
        name: "add_complaint",
        component: AddComplaint,
        meta: {
          title: "Add Complaint",
        },
      },
      {
        path: "update_complaint/:id",
        name: "update_complaint",
        component: UpdateComplaint,
        meta: {
          title: "Update Complaint",
        },
      },
      {
        path: "complaint_details/:id",
        name: "complaint_details",
        component: ComplaintDetails,
        meta: {
          title: "Complaint Details",
        },
      },
      {
        path: "complaint_log",
        name: "complaint_log",
        component: DeviceComplaintLog,
        meta: {
          title: "Device Complaint Log",
        },
      },
      {
        path: "solved_complaint_details/:id",
        name: "solved_complaint_details",
        component: SolvedComplaintDetails,
        meta: {
          title: "Solved Complaint Details",
        },
      },

      {
        path: "bank_accounts",
        name: "bank_accounts",
        component: BankAccounts,
        meta: {
          title: "Bank Accounts",
        },
      },
      {
        path: "bank_account_transactions/:bank_id",
        name: "bank_account_transactions",
        component: BankAccountTransactions,
        meta: {
          title: "Bank Transactions",
        },
      },
      {
        path: "user_accounts",
        name: "user_accounts",
        component: UserAccounts,
        meta: {
          title: "User Accounts",
        },
      },
      {
        path: "user_payment_logs/:id?",
        name: "user_payment_logs",
        component: UserPaymentLogs,
        meta: {
          title: "User Payment Logs",
        },
      },
      {
        path: "user_credit_logs/:id?",
        name: "user_credit_logs",
        component: UserCreditLogs,
        meta: {
          title: "User Credit Logs",
        },
      },
      {
        path: "user_dues/:id?",
        name: "user_dues",
        component: UserDues,
        meta: {
          title: "User Dues",
        },
      },
      {
        path: "user_account_payment/:id",
        name: "user_account_payment",
        component: UserAccountPayment,
        meta: {
          title: "User payment",
        },
      },
      {
        path: "vendor_credits",
        name: "vendor_credits",
        component: VendorCredits,
        meta: {
          title: "Vendor Accounts",
        },
      },
      {
        path: "vendor_invoices/:id?",
        name: "vendor_invoices",
        component: VendorInvoices,
        meta: {
          title: "Vendor Invoices",
        },
      },
      {
        path: "vendor_payment/:id",
        name: "vendor_payment",
        component: VendorPayment,
        meta: {
          title: "Vendor Payment",
        },
      },
      {
        path: "courier_account",
        name: "courier_account",
        component: CourierAccount,
        meta: {
          title: "Courier Account Management",
        },
      },
      {
        path: "verify_courier/:courier_id",
        name: "verify_courier",
        component: VerifyCourier,
        meta: {
          title: "Verify Courier Payment",
        },
      },
      {
        path: "courier_repayment/:courier_id",
        name: "courier_repayment",
        component: CourierRepayment,
        meta: {
          title: "Courier Repayment",
        },
      },
      {
        path: "courier_details/:courier_id",
        name: "courier_details",
        component: CourierDetails,
        meta: {
          title: "Courier Details",
        },
      },
      {
        path: "payment_in",
        name: "payment_in",
        component: PaymentIn,
        meta: {
          title: "Payment In",
        },
      },
      {
        path: "expense",
        name: "expense",
        component: Expense,
        meta: {
          title: "Expense",
        },
      },
      {
        path: "purchase",
        name: "purchase",
        component: Purchase,
        meta: {
          title: "Purchase",
        },
      },
      {
        path: "sales",
        name: "sales",
        component: Sales,
        meta: {
          title: "Sales",
        },
      },
      {
        path: "edit_sale/:id",
        name: "edit_sale",
        component: EditSale,
        meta: {
          title: "Edit Sale",
        },
      },
      {
        path: "expired_devices",
        name: "expired_devices",
        component: ExpiredDevices,
        meta: {
          title: "Expired Devices",
        },
      },
      {
        path: "renewed_devices",
        name: "renewed_devices",
        component: RenewedDevices,
        meta: {
          title: "Renewed Devices",
        },
      },
      {
        path: "update_vehicle_data/:imei",
        name: "update_vehicle_data",
        component: UpdateVehicleData,
        meta: {
          title: "Update Vehicle Data",
        },
      },
      {
        path: "recharge_device/:device_id",
        name: "recharge_device",
        component: RechargeDevice,
        meta: {
          title: "Recharge Device",
        },
      },
      {
        path: "safe_custody",
        name: "safe_custody",
        component: SafeCustodyDevices,
        meta: {
          title: "Safe Custody Devices",
        },
      },
      {
        path: "deactivated_devices",
        name: "deactivated_devices",
        component: DeactivatedDevices,
        meta: {
          title: "Deactivated Devices",
        },
      },
      {
        path: "upcomimg_expire_devices",
        name: "upcomimg_expire_devices",
        component: UpcomingExpiringDevices,
        meta: {
          title: "Upcoming Expire Devices",
        },
      },
      {
        path: "pending_payments",
        name: "pending_payments",
        component: PendingPayments,
        meta: {
          title: "Pending Payments",
        },
      },
      {
        path: "requested_devices",
        name: "requested_devices",
        component: RequestedDevices,
        meta: {
          title: "Requested Devices",
        },
      },
      {
        path: "recharged_devices",
        name: "recharged_devices",
        component: RechargedDevices,
        meta: {
          title: "Recharged Devices",
        },
      },
      {
        path: "enquiry_devices",
        name: "enquiry_devices",
        component: EnquiryDevices,
        meta: {
          title: "Enquiry Devices",
        },
      },
      {
        path: "all_devices",
        name: "all_devices",
        component: AllDevices,
        meta: {
          title: "All Devices",
        },
      },
      {
        path: "renewal_logs/:id",
        name: "renewal_logs",
        component: RenewalLogs,
        meta: {
          title: "Renewal Logs",
        },
      },

      {
        path: "settings",
        name: "settings",
        component: Settings,
        meta: {
          title: "Settings",
        },
      },

      {
        path: "raw_material_stock_report",
        name: "raw_material_stock_report",
        component: RawMaterialStockReport,
        meta: {
          title: "Raw Material Stock Report",
        },
      },
      {
        path: "work_report",
        name: "work_report",
        component: WorkReport,
        meta: {
          title: "Work Report",
        },
      },
      {
        path: "tag_report",
        name: "tag_report",
        component: TagReport,
        meta: {
          title: "Tag Report",
        },
      },
      {
        path: "call_log_report",
        name: "call_log_report",
        component: CallLogReport,
        meta: {
          title: "Call Log Report",
        },
      },
      {
        path: "pending_service_payments",
        name: "pending_service_payments",
        component: PendingServicePayments,
        meta: {
          title: "Pending Service Payments",
        },
      },
      {
        path: "support_services",
        name: "support_services",
        component: SupportServices,
        meta: {
          title: "Support Services",
        },
      },
      {
        path: "device_extension/:device_id",
        name: "device_extension",
        component: DeviceExtension,
        meta: {
          title: "Device Extension",
        },
      },
      {
        path: "device_topup/:device_id",
        name: "device_topup",
        component: DeviceTopup,
        meta: {
          title: "Device Topup",
        },
      },
      {
        path: "iccid_details/:device_id",
        name: "iccid_details",
        component: IccidDetails,
        meta: {
          title: "ICCID Details",
        },
      },
      {
        path: "extended_devices",
        name: "extended_devices",
        component: ExtendedDevices,
        meta: {
          title: "Extended Devices",
        },
      },
      {
        path: "suppliers",
        name: "suppliers",
        component: Suppliers,
        meta: {
          title: "Suppliers",
        },
      },
      {
        path: "products",
        name: "products",
        component: Products,
        meta: {
          title: "Products",
        },
      },
      {
        path: "product_stock_logs/:id",
        name: "product_stock_logs",
        component: ProductStockLogs,
        meta: {
          title: "Product Stock Logs",
        },
      },
      {
        path: "supports",
        name: "supports",
        component: Supports,
        meta: {
          title: "Support Management",
        },
      },
      {
        path: "add_support",
        name: "add_support",
        component: AddSupport,
        meta: {
          title: "Add Support",
        },
      },
      {
        path: "support_details/:id",
        name: "support_details",
        component: SupportDetails,
        meta: {
          title: "Support Details",
        },
      },
      {
        path: "completed_supports",
        name: "completed_supports",
        component: CompletedSupports,
        meta: {
          title: "Completed Supports",
        },
      },
      {
        path: "api_requesters",
        name: "api_requesters",
        component: ApiRequesters,
        meta: {
          title: "API Requesters",
        },
      },
      {
        path: "api_requester_logs/:id",
        name: "api_requester_logs",
        component: ApiRequesterLogs,
        meta: {
          title: "API Requester Access Logs",
        },
      },

      {
        path: "commands",
        name: "commands",
        component: Commands,
        meta: {
          title: "Commands",
        },
      },
    ]
  },
  {
    path: '/',
    component: Body,
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
          title: 'AIROTRACK STAFF Dashboard',
        }
      },
    ]
  },


  {
    path: '/',
    children: [
      {
        path: 'login',
        name: 'Login',
        component: login,
        meta: {
          title: 'Login | AIROTRACK STAFF',
        }
      },
      {
        path: 'register',
        name: 'register 1',
        component: Register,
        meta: {
          title: 'Register | AIROTRACK STAFF',
        }
      }
    ]
  },

]
const router = createRouter({
  history: createWebHistory(),
  routes,
})
router.beforeEach((to, from, next) => {
  if (to.meta.title)
    document.title = to.meta.title;
  const path = ['/login', '/register'];
  if (path.includes(to.path) || localStorage.getItem('airotrack_staff')) {
    return next();
  }
  next('/login');
});
export default router